<script lang="ts" setup>
defineProps({
  blur: {
    default: '',
    type: String,
  },
  blurStrength: {
    default: 16,
    type: Number,
  },
  bottom: {
    default: '',
    type: String,
  },
  from: {
    default: 'from-gray-50 dark:from-gray-950',
    type: String,
  },
  image: {
    default: undefined,
    type: String as PropType<BackgroundImage>,
  },
  imageClass: {
    default: '',
    type: String,
  },
  left: {
    default: '',
    type: String,
  },
  particles: {
    default: false,
    type: Boolean,
  },
  reverse: {
    default: false,
    type: Boolean,
  },
  right: {
    default: '',
    type: String,
  },
  section: {
    default: true,
    type: Boolean,
  },
  to: {
    default: 'to-transparent dark:to-transparent',
    type: String,
  },
  top: {
    default: '',
    type: String,
  },
})

const filterId = 'svg-blur'
</script>

<template>
  <div
    class="absolute left-0 size-full overflow-visible"
    :class="{
      'top-0': !reverse,
      'bottom-0': reverse,
    }"
    inert
  >
    <svg
      v-if="!$device.isSafari"
      class="absolute"
      height="0"
      width="0"
    >
      <defs>
        <filter :id="filterId">
          <feGaussianBlur :stdDeviation="blurStrength" />
        </filter>
      </defs>
    </svg>

    <div
      v-if="image"
      class="absolute inset-0 size-full opacity-100 dark:opacity-75"
      :class="imageClass"
      :style="{
        backgroundImage: !$device.isSafari
          ? `url(/images/bases/BaseMask/${image}.webp)`
          : `url(/images/bases/BaseMask/${image}-blurred.webp)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        filter: `url(#${filterId})`,
      }"
    />

    <div
      class="absolute -top-px h-[110%] w-full transform-gpu"
      :class="[
        {
          '-top-px bg-gradient-to-b': !reverse,
          '-bottom-px bg-gradient-to-t': reverse,
        },
        top,
        from,
        to,
      ]"
    />

    <div
      class="absolute h-[110%] w-full transform-gpu"
      :class="[
        {
          '-bottom-px bg-gradient-to-t': !reverse,
          '-top-px bg-gradient-to-b': reverse,
        },
        bottom,
        from,
        to,
      ]"
    />

    <ClientOnly>
      <AnimateParticlesBackground
        v-if="particles"
        :blur-strength="blurStrength"
        class="absolute inset-0 size-full transform-gpu opacity-50 dark:opacity-80"
        color="#6366f1"
        :max-size="6"
        :min-size="3"
        :quantity="30"
        :staticity="40"
      />
    </ClientOnly>

    <div
      v-if="section"
      class="absolute bottom-0 h-full w-[15%] transform-gpu"
      :class="[
        {
          '-left-px bg-gradient-to-r': !reverse,
          '-right-px bg-gradient-to-l': reverse,
        },
        left,
        from,
        to,
      ]"
    />

    <div
      v-if="section"
      class="absolute bottom-0 h-full w-[15%] transform-gpu"
      :class="[
        {
          '-right-px bg-gradient-to-l': !reverse,
          '-left-px bg-gradient-to-r': reverse,
        },
        right,
        from,
        to,
      ]"
    />
  </div>
</template>
